import { render } from "./SupplierImport.vue?vue&type=template&id=b79d03d6"
import script from "./SupplierImport.vue?vue&type=script&lang=js"
export * from "./SupplierImport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__